import { FileUtils } from "../../../../../common/utils/file_utils";
import { ICreateObraArquivoUseCase } from "../../../presentation/useCases/create/create_obra_arquivo_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * Enum Status
 */

enum ObraArquivoStatus {
  ATIVO = 1,
  OBSOLETO = 2,
}

/**
 * CreateObraArquivoUseCase
 */

export class CreateObraArquivoUseCase implements ICreateObraArquivoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObraArquivo(
    idObra: number,
    statusArquivo: number,
    nomeDocumento: string,
    file: File | null,
    dataVencimento: Date | null,
  ): Promise<void> {
    if (file === null) return;

    const obsoleto = statusArquivo === ObraArquivoStatus.OBSOLETO;
    const arquivo = await FileUtils.readFileAsBase64(file);
    const arquivoNome = file.name;

    if (!arquivo) throw new Error("Falha ao processar o arquivo!");

    await this.repository.createObraArquivo(
      idObra,
      obsoleto,
      nomeDocumento,
      arquivoNome,
      arquivo,
      dataVencimento,
    );
  }
}
